import { render, staticRenderFns } from "./alert-types.vue?vue&type=template&id=1f67be75&"
import script from "./alert-types.vue?vue&type=script&lang=js&"
export * from "./alert-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports